<div class="row">
  <div class="col">
    <app-eca-input label="Name" [isRequired]="true" [controlId]="'ctrlDocTypeName'"
                   [isReadOnly]="!editingType"

                   [(value)]="documentType.name"
                   [isValid]="!saveAttempted || !!documentType?.name"
                   validationMessage="Please enter the name for the training course/type"
                   popoverText="Please enter a short name for the training course/type to refer to it later">
    </app-eca-input>
  </div>
</div>
<div class="row">
  <div class="col">
    <app-eca-html-editor label="Description"
                         popoverText="Enter the details of the document type"
                         [(content)]="documentType.description"
                         [isReadOnly]="!editingType"
                         [isRequired]="true"
                         [isValid]="!saveAttempted || !!documentType?.description"
                         validationMessage="Please enter the description for the document type">
    </app-eca-html-editor>
  </div>
</div>
